import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard, AuthGuard } from './services';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FlightResultComponent } from './flight/flight-result/flight-result.component';
import { DomainConfig } from './config/domain.config';

let routes: Routes = [];

if (DomainConfig.isCorporate) { // uatcorporate.belairtrip.com
  routes = [
    { path: '', redirectTo: '', pathMatch: 'full' },
    { path: '', loadChildren: () => import('./corporate-flight/corporate-flight.module').then(m => m.CorporateFlightModule), canActivate: [LoginGuard] },
    { path: 'u', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), canActivate: [AuthGuard] },
    { path: 'PaymentStatus', loadChildren: () => import('./pg/pg.module').then(m => m.PgModule)},
    { path: 'airCart', loadChildren: () => import('./air-cart/air-cart.module').then(m => m.AirCartModule)},
  ]
} else {
  routes = [
    { path: '', redirectTo: '', pathMatch: 'full' },
    { path: 'PaymentStatus', loadChildren: () => import('./pg/pg.module').then(m => m.PgModule)},
    { path: 'airCart', loadChildren: () => import('./air-cart/air-cart.module').then(m => m.AirCartModule)},
    { path: 'payGate',  loadChildren: () => import('./pg/pg.module').then(m => m.PgModule) },
    // { path: 'b2c/hotel', loadChildren: () => import('./hotel/hotel.module').then(m => m.HotelModule) },
    { path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), canActivate: [LoginGuard] }, // Only for redirect B2B login system in auth part
    { path: 'u', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'page-not-found' },
    { path: 'b2c', component: FlightResultComponent },
    { path: 'page-not-found', component: NotFoundComponent },
  ];
}

@NgModule({


  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', useHash: false // Add options right here
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
